import MakeAdmin from './MakeAdmin';

export default MakeAdmin;
